<template>
  <section>
    <HomeHeader />

    <TrailResume v-if="isLogged" />

    <TrailPresentation v-if="isLogged" />

    <CoursesOngoing v-if="isLogged" />

    <LivesScheduled />

    <CoursePremium v-if="hasUserSubscriptionAccess" />

    <CoursesIndex />

    <CourseFree />

    <BooksLatestList />

    <!-- <ComingSoonCourses /> -->

    <AuthorsHighlight />

    <BlogPosts />

    <CallToSignUp
      v-if="!hasUserSubscriptionAccess"
    />

    <!-- <Popup v-if="isLogged">
      <Igclub />
    </Popup> -->

  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import CoursesOngoing from '@/components/home/CoursesOngoing'
import LivesScheduled from '@/components/home/LivesScheduled'
import AuthorsHighlight from '@/components/home/AuthorsHighlight'
import CoursesIndex from '@/components/home/CoursesIndex'
import CourseFree from '@/components/home/CourseFree'
import CoursePremium from '@/components/home/CoursePremium'
import CallToSignUp from '@/components/home/CallToSignUp'
import ComingSoonCourses from '@/components/home/ComingSoonCourses'
import BooksLatestList from '@/components/book/BooksLatestList'
import HomeHeader from '@/components/home/HomeHeader'
import BlogPosts from '@/components/home/BlogPosts'
import TrailResume from '@/components/trail/TrailResume'
import TrailPresentation from '@/components/trail/TrailPresentation'
import Popup from '@/components/modals/Popup.vue';
import Igclub from '@/components/ads/Igclub.vue';

export default {
  components: {
    CallToSignUp,
    TrailResume,
    TrailPresentation,
    CoursesIndex,
    CourseFree,
    CoursePremium,
    CoursesOngoing,
    LivesScheduled,
    AuthorsHighlight,
    ComingSoonCourses,
    BooksLatestList,
    HomeHeader,
    BlogPosts,
    Popup,
    Igclub,
  },

  metaInfo() {
    return {
      title: `CyberClass - Conhecimento para conquistar seus objetivos`,
      meta: [
        {
          property: "description",
          content: `Cursos e Lives realizados por experts de suas áreas. Pessoas que assim como você tiveram um sonho e conquistaram seus objetivos através do conhecimento.`,
        },
      ],
    };
  },

  computed: {
    ...mapGetters("user", ["isLogged", "hasUserSubscriptionAccess"]),

    ...mapGetters("subscription", ["subscription"]),
  },
};
</script>
